<template>
  <VTooltip
    position="below"
    padding-class="tw-px-3 tw-py-2"
    :hide-tooltip-arrow="hideTooltipArrow"
    data-test-id="vBookmark"
  >
    <i
      :class="`fa-bookmark icon ${bookmarkedClass}`"
      data-test-id="vBookmarkIcon"
      @click.stop="openBucketModal"
    />
    <template #tooltipText>
      {{
        isInBucket
          ? $t('agency.favorites.savedToBucket')
          : $t('agency.favorites.saveToBucket')
      }}
    </template>
  </VTooltip>
</template>

<script lang="ts">
import { mapActions } from 'pinia'
import { defineComponent } from 'vue'

import VTooltip from '~/components/ui/VTooltip.vue'

import EventsMixin from '~/mixins/events'
import SegmentEventsMixin from '~/mixins/Segment/BucketList'

import { useUserFavoritesStore } from '~/stores/userFavorites'

import type {
  default as Influencer,
  StatsV3Influencer,
} from '~/types/influencer'
import type { OriginPageName } from '~/types/Segment/SegmentEventLibrary/SegmentEventLibraryBucketList'
import type { PropType } from 'vue'

export default defineComponent({
  name: 'VBookmark',
  components: {
    VTooltip,
  },
  mixins: [EventsMixin, SegmentEventsMixin],
  props: {
    campaignId: {
      type: Number,
      required: false,
    },
    influencer: {
      type: Object as PropType<Influencer | StatsV3Influencer | undefined>,
      required: false,
      default: undefined,
    },
    hideTooltipArrow: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    isInBucket(): boolean {
      return this.influencer
        ? this.INF_ID_IS_IN_BUCKET(this.influencer.id)
        : false
    },
    bookmarkedClass(): string {
      let bookmarkClassList = ''

      bookmarkClassList = this.isInBucket
        ? 'fas tw-bg-gradient-135 tw-bg-grooverGradient'
        : 'far hover:tw-bg-gradient-135 hover:tw-bg-grooverGradient'

      bookmarkClassList +=
        this.originPage === 'curator-profile'
          ? ' tw-text-white md:tw-text-gray-500 hover:tw-text-transparent'
          : ' tw-text-gray-500 hover:tw-text-transparent'

      return bookmarkClassList
    },
    originPage(): OriginPageName {
      const { getOriginPage } = useCuratorAddGetOriginPage(this.$route)

      return getOriginPage() || 'curator-card'
    },
  },
  methods: {
    ...mapActions(useUserFavoritesStore, [
      'SET_INSPECTED_INFLUENCERS',
      'INF_ID_IS_IN_BUCKET',
    ]),
    openBucketModal(): void {
      if (this.influencer) {
        this.SET_INSPECTED_INFLUENCERS([this.influencer])
        this.SET_ORIGIN_PAGE(this.originPage)

        if (this.campaignId) this.SET_CAMPAIGN_ID(this.campaignId)

        const details = this.trackListSaveInitiated([this.influencer])
        this.trackEvent({
          category: 'Bucket Management',
          action: 'Save Initiated',
          details,
        })
      }
    },
  },
})
</script>

<style lang="scss" scoped>
.icon {
  @apply tw-cursor-pointer tw-rounded-xs tw-bg-clip-text tw-text-base;
}
</style>
